import { readScopedToken } from '../session/storage.js';

export async function startGoogleSignIn(): Promise<void> {
  const token = readScopedToken();
  const response = await fetch('/api/auth/google?response=json', {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  if (!response.ok) {
    const body = await response.json().catch(() => null) as { error?: string } | null;
    throw new Error(body?.error || `google_sign_in_${response.status}`);
  }

  const body = await response.json() as { url?: string };
  if (!body.url) throw new Error('oauth_url_missing');
  window.location.assign(body.url);
}
